import { useContext } from "react";
import { CircleLoader, PageHeader } from "components";
import { Filter, Results } from './components';
import { toolTypologiesContext } from './ToolTypologiesContext';


let WorkLogs = () => {
    let service = useContext(toolTypologiesContext);


    return (
        <>
            <PageHeader pageTitle={"Tipologie Strumenti"} addNewUrl={`/toolTypology/addnew/`} />

            <Filter />

            {service.isLoading && <CircleLoader />}
            {service.isLoading === false && <Results />}
        </>
    );
}

export default WorkLogs;